import 'core-js';
import $ from 'jquery';
import 'bootstrap';
import Version from './lib/Version';
import Timer from './lib/Timer';
import Service from './lib/ajax/Service';
import UrlHelper from './lib/ajax/UrlHelper';
import FieldValidationProvider from './lib/FieldValidationProvider';
import PromoCodeProvider from './lib/PromoCodeProvider';
import Messaging from './ui/Messaging';
import App from './App';
import TimerHandler from '../cart/timer/TimerHandler';
import FormButtonHandler from './handlers/FormButtonHandler';
import GoogleDataLayerProvider from './lib/GoogleDataLayerProvider';
import { loadIssueCollector } from '../AsyncLoader';
import { register as stateFilterRegistration } from './lib/StateFilterRegistration';


const timerHandler = new TimerHandler();
timerHandler.initialize();

const formButtonHandler = new FormButtonHandler();
formButtonHandler.listen();

const promoCodeProvider = new PromoCodeProvider();

const app = new App();

const tnew = {
  $,
  jQuery: $,
  events: {
    loaded: $,
  },
  app,
  page: {},
  lib: {
    Version,
    Timer,
    FieldValidationProvider,
    GoogleDataLayerProvider,
    events: {},
    ajax: {
      Service,
      UrlHelper,
    },
    admin: {
      content: {},
    },
    api: {
      tnew: {
        account: {},
        system: {},
        products: {},
        cart: {
          payment: {},
        },
      },
    },
  },
  ui: {
    messaging: Messaging,
    stateFilter: {
      register: stateFilterRegistration,
    },
  },
  handlers: {
    formButtonHandler,
    timerHandler,
  },
};

window.tnew = tnew;

$(() => {
  // lazy-load issue-collector.js when DOM is ready
  loadIssueCollector();
});


// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/tnew-service-worker.js');
//   });
// }


export {
  formButtonHandler,
  app,
};



// WEBPACK FOOTER //
// ./V7/tnew/tnew.js